import { render, staticRenderFns } from "./Requisitions.vue?vue&type=template&id=4e098fdc&lang=pug&"
import script from "./Requisitions.vue?vue&type=script&lang=js&"
export * from "./Requisitions.vue?vue&type=script&lang=js&"
import style0 from "./Requisitions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports